import CompareCosts from "./CompareCosts";
import { OrderCosts } from "./helpers";

export const BillableItemCost = ({ costs }: { costs: OrderCosts }) => {
  const billable =
    +costs.billableTotalActualCost || +costs.billableTotalEstimatedCost;
  const estimate = +costs.totalActualCost || +costs.totalEstimatedCost;

  return <CompareCosts cost={billable} comparedTo={estimate} />;
};

export const BillableBeaconCost = ({ costs }: { costs: OrderCosts }) => {
  const billable = +costs.billableTotalBeaconCost;
  const estimate = +costs.totalBeaconCost;

  return <CompareCosts cost={billable} comparedTo={estimate} />;
};

export const BillableShippingCost = ({ costs }: { costs: OrderCosts }) => {
  const billable =
    +costs.billableTotalActualShippingCost ||
    +costs.billableTotalEstimatedShippingCost;
  const estimate =
    +costs.totalActualShippingCost || +costs.totalEstimatedShippingCost;

  return <CompareCosts cost={billable} comparedTo={estimate} />;
};

export const BillableTaxCost = ({ costs }: { costs: OrderCosts }) => {
  const billable = +costs.billableTotalEstimatedTax;
  const estimate = +costs.totalEstimatedTax;

  return <CompareCosts cost={billable} comparedTo={estimate} />;
};
